/** Query key of the signed-in user's Widget Subscriptions; invalidated when a change can pause or end one. */
export const SUBSCRIPTIONS_KEY = ['widget-subscriptions'];
